import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createSubCategoryAction = createAsyncThunk(
    'create-sub-category',
    async (data = null, { rejectWithValue }) => {
        try {

            const res = await axios.post(`/admins/api/create-sub-category`, {...data})
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createSubCategorySlice = createSlice({
    name: 'create-sub-category',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createSubCategoryAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createSubCategoryAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createSubCategoryAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createSubCategoryReducer = createSubCategorySlice.reducer    